import { window } from '../../../../globals';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import { hardRedirectTo } from '../../../../utils';
import type { GitHubAppInstallUrlResponse, InstallUrlRequest } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const startGitHubAppInstall = async (app: VcsApp) => {
  /*
   * Send the current path so the install-callback returns the user here (the import page). The
   * import page keeps `connect` in the URL while its connect modal is open, and "Install on another
   * account" starts from that modal, so drop the flag or the user would land back on the modal.
   * Deleting re-encodes the whole query string, so only do it when the flag is there: every other
   * caller's path goes out exactly as the browser has it.
   */
  const url = new URL(window.location.href);
  if (url.searchParams.has('connect')) {
    url.searchParams.delete('connect');
  }
  const returnPath = `${url.pathname}${url.search}`;
  const response = await post<InstallUrlRequest, GitHubAppInstallUrlResponse>(
    `/api/vcs/github-apps/${app}/install-url`,
    { returnPath },
  );
  return response.data as GitHubAppInstallUrlResponse;
};

/**
 * Asks vcs-service for a GitHub App install URL and redirects the user to it.
 * The install completes when GitHub redirects back to
 * `/api/vcs/github-apps/install-callback`.
 */
export function useStartGitHubAppInstall() {
  return useToastedMutation({
    mutationFn: startGitHubAppInstall,
    onSuccess: ({ installUrl }) => {
      hardRedirectTo(installUrl);
    },
    errorToastMessage: 'Failed to start GitHub App installation',
  });
}
